import { ReactComponent as AlertTriangle } from "@/components/common/icons/alert-triangle.svg";
import { cn } from "@/utils/cn";

const ErrorBanner: React.FC<{
  children: React.ReactNode;
  parentAdditionalClassName?: string;
  showIcon?: boolean;
}> = ({ children, parentAdditionalClassName = "", showIcon = true }) => {
  return (
    <div
      className={cn(
        "bg-coral/70 p-4 flex my-auto items-center rounded-lg",
        parentAdditionalClassName
      )}
    >
      {showIcon && <AlertTriangle className="stroke-evvy-black h-4 w-5 mr-1" />}
      <span className="b2 medium">{children}</span>
    </div>
  );
};

export default ErrorBanner;
